import React from 'react'
import PropTypes from 'prop-types'

export const MockupGeneratorListProduct = (props) => {

    const {columns, columnQuantity} = props
    const mappedColumns = columns.length ? columns : new Array(columnQuantity).fill(null)

    return (
        <div className={`ContentListProductMockup`}>
            {mappedColumns.map((column, i) => (
                <div key={i} className="lightui1">
                    <div className="lightui1-shimmer">
                        <div className="_2iwz"/>
                        <div className="_2iw-"/>
                        <div className="_2iw_"/>
                        <div className="_2ix0"/>
                        <div className="_2ix01"/>
                    </div>
                </div>

            ))}
        </div>
    )

}

MockupGeneratorListProduct.defaultProps = {
    columns: [],
    columnQuantity: 0,
}

MockupGeneratorListProduct.propTypes = {
    columns: PropTypes.array,
    columnQuantity: PropTypes.number,
}

export default MockupGeneratorListProduct
